import { render, staticRenderFns } from "./NbBox.vue?vue&type=template&id=4ebb33b8&scoped=true&"
import script from "./NbBox.vue?vue&type=script&lang=js&"
export * from "./NbBox.vue?vue&type=script&lang=js&"
import style0 from "./NbBox.vue?vue&type=style&index=0&id=4ebb33b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebb33b8",
  null
  
)

export default component.exports